import { action } from '@reatom/framework'

import { RafBuffer } from '@blade/std-lib'
import { rootCtx } from '@root/shared/lib/reatom/root-ctx'

import type { Trade } from '@root/entities/trade'

// eslint-disable-next-line @reatom/unit-naming-rule
export const newTxEvent = action<Trade.Trade>('newTxEvent')

// eslint-disable-next-line @reatom/unit-naming-rule
export const newTxBufferedEvents = action<ReadonlyArray<Trade.Trade>>(
  'newTxBufferedEvents',
)

export const newTxRafBuffer = RafBuffer.createRafBuffer<Trade.Trade>((items) =>
  newTxBufferedEvents(rootCtx, items),
)
